// @ts-strict-ignore
import { Component, AfterViewInit } from '@angular/core';
import { LMContextService } from '@services/lm-context.service';
import { LMContextUtilService } from '@utils/lm-context-util.service';
import { LMUrlUtilService } from '@services/utils/lm-url-util.service';

@Component({
  selector:    'lm-view-more',
  standalone: false,
  templateUrl: 'lm-view-more.component.html',
  styleUrls: [ 'lm-view-more.component.scss' ],
})

export class LMViewMoreComponent implements AfterViewInit {
  public viewMore: String = Soho.Locale.translate('ViewMore');

  constructor(
    public lmContextService: LMContextService,
    private lmUrlUtilService: LMUrlUtilService,
    public lmContextUtilService: LMContextUtilService) {
  }

  ngAfterViewInit() {
    //    setTimeout(() => {
    //      this.viewMore = Soho.Locale.translate('ViewMore');
    //    }, 50);
  }

  public onViewMoreLink(event) {
    const searchString = 'nav='; let url = ' ';
    let tempUrl = '';
    if (document.baseURI) {
      tempUrl = document.baseURI;
    } else {
      tempUrl = document.URL;
    }

    const index = tempUrl.indexOf(searchString);

    if (index > 0) {
      url = decodeURIComponent(tempUrl.substring(index + searchString.length));
      let targetUrlResourceType = ''; let targetUrlResourceId = ''; let targetUrlParams = '';
      const vars = url.split('&');

      for (let i = 0; i < vars.length; i++) {
        const pair = vars[i].split('=');

        if (pair[0] === 'targetUrlResourceType') {
          targetUrlResourceType = pair[1];
        } else if (pair[0] === 'targetUrlResourceId') {
          targetUrlResourceId = pair[1];
        } else if (pair[0] === 'targetUrlParams') {
          targetUrlParams = pair[1];
        }
      }

      if (targetUrlResourceType !== '' && targetUrlResourceId !== '') {       // navigating to a list or form.
        url = this.lmUrlUtilService.getBaseUrl();
        url += '/' + targetUrlResourceType + '/' + targetUrlResourceId;

        if (targetUrlParams !== '') {
          url += '?relation=' + targetUrlParams;
        }
      } else {
        const protocol = url.substring(0, 4);                                   // checking for absolute or relative url

        if (protocol !== 'http') {
          const context = this.lmContextService.getContext();
          const relativeUrl = url;
          url = location.protocol + '//' + location.host + '/' + context.urlPdlOrDa;

          if (relativeUrl.substring(0, 1) === '/') {
            url += relativeUrl;
          } else {
            url += '/' + relativeUrl;
          }
        }
      }

      url = this.lmUrlUtilService.updateContextSessionKeyParams(url);
    } else {
      url = tempUrl;
    }

    const res = url.replace('mw=true', 'mw=false');

    this.lmContextUtilService.sendDrillbackMessage(res);
  }
}
